import type { Prospect } from '@hc-frontend/core-types';

type ReplaceParamsProps = {
  lead: Prospect | undefined;
  partnerName: string | undefined;
  dynamicText: string | undefined;
};

export function replaceDynamicTextProps(params: ReplaceParamsProps) {
  const { lead, partnerName, dynamicText } = params;

  if (!dynamicText) {
    return '';
  }

  let text = dynamicText;
  text = text.replace(
    '{email_address}',
    lead?.contactInformation?.email ?? 'your email address',
  );

  text = text.replace(
    ', {first_name}',
    lead?.contactInformation?.firstName
      ? `, ${lead?.contactInformation?.firstName}`
      : '',
  );

  text = text.replace(
    '{first_name}, ',
    lead?.contactInformation?.firstName
      ? `${lead?.contactInformation?.firstName}, `
      : '',
  );

  text = text.replace('{partner_name}', partnerName ?? '');

  return text;
}
